import Vue from "vue";
import Vuex from "vuex";
import { API, graphqlOperation } from "aws-amplify";
import "../graphql/queries";
import "../graphql/mob_queries";
import { createSubject, updateOrderr } from "../graphql/mutations";
import { Auth } from "aws-amplify";
import APIAdapter from "./APIAdapter";
import moment from "moment";
import LocaleUtil from "../libs/LocaleUtil";
import DateUtil from "../libs/DateUtil";
import TransformUtil from "../libs/TransformUtil";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appVersion: "1.119.0",

    // kontext klienta
    client: "23", // nastaveno globalne pri inicializaci aplikace
    appInstance: "23", // nastaveno globalne pri inicializaci aplikace

    mobConfig: null,
    rentSelectSizeAutomatic: true,
    mobRentIcon: "mdi-ski",
    mobSchoolIcon: "mdi-ski",
    locales: ["sk",  "en", "hu"],
    locale: "sk",
    courseLanguages: ["sk", "hu", "en", "de"],
    courseGroupClientLanguages: ["sk",  "en"],
    coursePrivateClientLanguages: ["sk",  "en"],
    courseGroupIsWholeDayRequired: false,

    rentDisabledPointSell: [], // pole s IDcky pobocek, ktere se NEmaji zobrazovat pro pujcovnu. Uvadi se mssId
    rentDatePickTryOutEnabled: true, // zobrazovat ci ne datumove policko pro zadani terminu vyzkouseni

    deliveryPoints: [],

    locations: [],
    location: null,
    pointSells: [],
    pointMeetings: [],
    pointSell: null,
    checkInDateSchool: moment().format("YYYY-MM-DD"), // vychozi hodnota je o 1 den navic
    checkOutDateSchool: moment().format("YYYY-MM-DD"), // vychozi hodnota je o 1 den navic
    checkInDateRent: moment().format("YYYY-MM-DD"),
    checkOutDateRent: moment().format("YYYY-MM-DD"),
    checkInDateMinRent: moment().format("YYYY-MM-DD"), // nejnizsi mozna hranice, od kdy lze rezerovat
    checkInDateMinSchool: moment().format("YYYY-MM-DD"),
    schoolPointMeetingInfo: null, // informace o meeting pointech - mapa
    schoolPointMeetingURL: null, // detailnejsi informace o meeting pointech. Zatim se nepouziva
    schoolSkillLevelClientInfo: null, // informace o dovednostnich urovnich klienta
    schoolSkillLevelClientURL: null, // URL na detailnejsi informace o urovnich klienta. Zatim se nepouziva
    user: null,
    segment: "RENT",
    // orderrs: [], // seznam vsech objednavek -- odstaveno
    currentOrderr: null,
    currentOrderrExpired: false, // staticky, aby nad Date objektem nemusel byt observu. Propisuje se po refreshi obj. a pri identifikaci expicitni expirace
    expireAt: null, // datum a cas, kdy objednavka expiruje. Ulozeno takto staticky kvuli eliminaci problikavani pri nacitani currentOrderr
    currentOrderrItemGroup: null,
    currentPayment: null,
    rentBookingMode: "CREATE",
    //articlesBySize: null,
    rentProduct: null,
    rentCategories: [],
    schoolCategories: [],
    staticContentList: [],
    rentProductRequirements: [],
    lastVisitedSegment: null, // jaky segment byl naposledy navstiven RENT nebo COURSE - pro ucely navratu na home page
  },
  mutations: {
    doSetMobConfig(state, payload) {
      state.mobConfig = payload;
    },

    doSetLastVisitedSegment(state, payload) {
      state.lastVisitedSegment = payload;
    },

    doLocaleChange(state, payload) {
      console.log(state.locale);
      state.locale = payload;
      console.log(state.locale);
    },

    doSetLocations(state, payload) {
      if (payload != null) {
        state.locations = payload.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });
      } else {
        state.locations = payload;
      }
    },

    doSetLocation(state, payload) {
      state.location = payload;
      if (payload != null) {
        console.log("Ukladam locatoin do COOKIE:");
        console.log(payload);
        Vue.$cookies.set("location", payload);
        console.log("kontrolni vypis:");
        console.log(Vue.$cookies.get("location"));
      } else {
        Vue.$cookies.remove("location");
      }
    },

    doSetPointSells(state, payload) {
      if (payload != null) {
        state.pointSells = payload.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });
      } else {
        state.pointSells = payload;
      }
    },

    doSetPointMeetings(state, payload) {
      if (payload != null) {
        state.pointMeetings = payload.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });
      } else {
        state.pointMeetings = payload;
      }
    },

    doSetPointSell(state, payload) {
      state.pointSell = payload;
      if (payload != null) {
        Vue.$cookies.set("pointSell", payload);
      } else {
        Vue.$cookies.remove("pointSell");
      }
    },

    doSetCheckInDateSchool(state, payload) {
      state.checkInDateSchool = payload;
      if (payload != null) {
        Vue.$cookies.set("checkInDateSchool", payload);
      } else {
        Vue.$cookies.remove("checkInDateSchool");
      }
    },

    doSetCheckOutDateSchool(state, payload) {
      state.checkOutDateSchool = payload;
      if (payload != null) {
        Vue.$cookies.set("checkOutDateSchool", payload);
      } else {
        Vue.$cookies.remove("checkOutDateSchool");
      }
    },

    doSetCheckInDateMinRent(state, payload) {
      state.checkInDateMinRent = payload;
    },

    doSetCheckInDateMinSchool(state, payload) {
      state.checkInDateMinSchool = payload;
    },

    doSetCheckInDateRent(state, payload) {
      state.checkInDateRent = payload;
      if (payload != null) {
        Vue.$cookies.set("checkInDateRent", payload);
      } else {
        Vue.$cookies.remove("checkInDateRent");
      }
    },

    doSetCheckOutDateRent(state, payload) {
      state.checkOutDateRent = payload;
      if (payload != null) {
        Vue.$cookies.set("checkOutDateRent", payload);
      } else {
        Vue.$cookies.remove("checkOutDateRent");
      }
    },

    doSetRentCategories(state, payload) {
      if (payload != null) {
        state.rentCategories = payload.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });
      } else {
        state.rentCategories = payload;
      }
    },

    doSetSchoolCategories(state, payload) {
      state.schoolCategories = payload;
    },

    doLogout(state) {
      state.user = null;
    },

    doLogin(state, user) {
      state.user = user;
    },

    doSetOrderr(state, orderr) {
      state.currentOrderr = orderr;
      if (orderr == null) {
        state.expireAt = null;
        Vue.$cookies.remove("orderrId");
      } else {
        state.expireAt = orderr.expireAt;
        Vue.$cookies.set("orderrId", orderr.id);
      }
    },

    doSetCurrentOrderrExpired(state, isExpired) {
      state.currentOrderrExpired = isExpired;
    },

    doSetOrderrs(state, payload) {
      state.orderrs = payload;
    },

    doSetRentProduct(state, rentProduct) {
      state.rentProduct = rentProduct;
    },

    doSaveRentSearchParams(state, location, checkInDate, length) {
      state.commit("doSetLocation", location);
      state.commit("doCheckInDate", checkInDate);
      state.length = length;
    },

    doSetCurrentPayment(state, payment) {
      state.currentPayment = payment;
    },

    doSetStaticContentList(state, staticContentList) {
      state.staticContentList = staticContentList;
    },

    doSetRentProductRequirements(state, rentProductRequirements) {
      state.rentProductRequirements = rentProductRequirements;
    },
  },

  actions: {
    async logout(context) {
      context.commit("doLogout");
    },

    async setLastVisitedSegment(context, segment) {
      context.commit("doSetLastVisitedSegment", segment);
    },
 
    async login(context, user) {
      context.commit("doLogin", user);
    },

    async localeChange(context, newLocale) {
      context.commit("doLocaleChange", newLocale);
    },

    async saveRentSearchParams(context, location, checkInDate, length) {
      context.commit("doSaveRentSearchParams", location, checkInDate, length);
    },

    async loadMobConfig(context) {
      console.log("loadMobConfig -- start:");
      let mobConfig = null;
      try {
        console.log("loadMobConfig -- volani:");
        mobConfig = await APIAdapter.getLatestMOBConfig(context.state.appInstance);
      } catch (e) {
        console.log("loadMobConfig -- ERROR");
        console.log(e);
      }

      console.log("loadMobConfig:");
      console.log(mobConfig);
      context.commit("doSetMobConfig", mobConfig);

      let bhStartHour = 8;
      let bhStartMinute = 30;
      let bhEndHour = 18;
      let bhEndMinute = 0;

      let offsetRent = mobConfig.rentBookingOffset; // in hours
      let offsetSchool = mobConfig.schoolBookingOffset; // in hours

      let rentTimeMin = moment().add(offsetRent, "hours");
      rentTimeMin = DateUtil.fitDateToBussinessHours(
        bhStartHour,
        bhStartMinute,
        bhEndHour,
        bhEndMinute,
        rentTimeMin
      );
      let schoolTimeMin = moment().add(offsetSchool, "hours");
      schoolTimeMin = DateUtil.fitDateToBussinessHours(
        bhStartHour,
        bhStartMinute,
        bhEndHour,
        bhEndMinute,
        schoolTimeMin
      );

      console.log("rentTimeMin:");
      console.log(rentTimeMin.format("YYYY-MM-DD HH:mm"));
      console.log("schoolTimeMin:");
      console.log(schoolTimeMin.format("YYYY-MM-DD HH:mm"));

      // context.commit("doSetCheckInDateRent", schoolTimeMin.format("YYYY-MM-DD"));
      // context.commit("doSetCheckOutDateRent", schoolTimeMin.format("YYYY-MM-DD"));

      context.commit("doSetCheckInDateRent", rentTimeMin.format("YYYY-MM-DD"));
      context.commit("doSetCheckOutDateRent", rentTimeMin.format("YYYY-MM-DD"));

      context.commit(
        "doSetCheckInDateMinRent",
        rentTimeMin.format("YYYY-MM-DD")
      );
      context.commit(
        "doSetCheckInDateMinSchool",
        schoolTimeMin.format("YYYY-MM-DD")
      );
    },

    async loadLocations(context) {
      let locations = await APIAdapter.listLocations(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      console.log("loadLocations:");
      console.log(locations);

      context.commit("doSetLocations", locations);

      if (
        context.state.location == null &&
        context.state.locations != null &&
        context.state.locations.length > 0
      ) {
        context.commit("doSetLocation", context.state.locations[0]);
      }
    },

    async loadPointSells(context) {
      let pointSells = await APIAdapter.listPointSell(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      console.log("loadPointSells:");
      console.log(pointSells);

      // vyfiltrovat nechtenne
      pointSells = pointSells.filter((ps) => {
        return !context.state.rentDisabledPointSell.includes(ps.mssId);
      });

      context.commit("doSetPointSells", pointSells);

      //console.log(context.state.pointSell == null);

      if (
        context.state.pointSell == null &&
        context.state.pointSells != null &&
        context.state.pointSells.length > 0
      ) {
        context.commit("doSetPointSell", context.state.pointSells[0]);
      }
    },

    async loadPointMeetings(context) {
      let pointMeetings = await APIAdapter.listPointMeeting(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      console.log("loadPointMeetings:");
      console.log(pointMeetings);

      context.commit("doSetPointMeetings", pointMeetings);
    },

    async loadListCategoriesAndProductsRent(context) {
      let result = await APIAdapter.loadListCategoriesAndProductsByProductType(
        context.state.appInstance,
        context.state.mobConfig.mobVersion,
        "RENTAL"
      );
      context.commit("doSetRentCategories", result);
    },

    async loadListCategoriesAndProductsSchool(context) {
      let result = await APIAdapter.loadListCategoriesAndProductsByProductType(
        context.state.appInstance,
        context.state.mobConfig.mobVersion,
        "SCHOOL"
      );
      console.log("loadListCategoriesAndProductsSchool");
      console.log(result);
      context.commit("doSetSchoolCategories", result);
    },

    // vytvoreni prazdne 0objednavky
    // napojeno na backend pres Mutation
    async createOrderr(context) {
      try {
        const createOrderrDraftIn = {
          appInstance: context.state.appInstance,
          groups: context.state.appInstance,
          mobVersion: context.state.mobConfig.mobVersion,
          orderrPointSellId: context.state.pointSell.id,
          language: LocaleUtil.transformLocaleToLanguage(context.state.locale),
        };

        let orderrId = await APIAdapter.createOrderrDraft(createOrderrDraftIn);

        console.log("objednavka zalozena");

        return await context.dispatch("getOrderr", orderrId);
      } catch (error) {
        console.error("Nepodarilo se zalozit objednavlku", error);
      }
    },

    // vola se jako akce pro zahajeni pridani polozky do kosiku
    async addToCart(context, orderrItemGroup) {
      console.log("store action addToCart");
      console.log(orderrItemGroup);

      //await context.dispatch("loadCurrentOrderrDRAFT");

      /// create orderr, jestlize neexistuje
      if (context.state.currentOrderr == null) {
        await context.dispatch("createOrderr");
        console.log("store action addToCart -- objednavka zalozena");
      }

      console.log("store action addToCart -- vytvareni subject profiles");
      console.log(orderrItemGroup.subjectProfiles);

      let subjectProfileIns = [];
      if (
        orderrItemGroup.subjectProfiles != null &&
        orderrItemGroup.subjectProfiles != undefined &&
        orderrItemGroup.subjectProfiles.length > 0 &&
        orderrItemGroup.subjectProfiles[0] != null
      ) {
        for (let i = 0; i < orderrItemGroup.subjectProfiles.length; i++) {
          let subjectProfileIn = {
            name: orderrItemGroup.subjectProfiles[i].name,
            surname: orderrItemGroup.subjectProfiles[i].surname,
            weight: orderrItemGroup.subjectProfiles[i].weight,
            height: orderrItemGroup.subjectProfiles[i].height,
            shoeSize: orderrItemGroup.subjectProfiles[i].shoeSize,
            age: orderrItemGroup.subjectProfiles[i].age,
            gender: orderrItemGroup.subjectProfiles[i].gender,
            rentAbilityLevel: orderrItemGroup.subjectProfiles[i].rentAbilityLevel,
            schoolSkillLevelClient: orderrItemGroup.subjectProfiles[i].schoolSkillLevelClient,
            note: orderrItemGroup.subjectProfiles[i].note,
          };
          if(orderrItemGroup.subjectProfiles[i].language != undefined && orderrItemGroup.subjectProfiles[i].language != null) {
            subjectProfileIn.language = orderrItemGroup.subjectProfiles[i].language;
          }
          subjectProfileIns.push(subjectProfileIn);
        }
      }

      console.log("store action addToCart -- vytvareni subject profiles - done");

      console.log("store action addToCart -- vytvareni orderrItemGroupIn");

      let orderrItemGroupIn = {
        groups: context.state.appInstance,
        appInstance: context.state.appInstance,
        mobVersion: context.state.mobConfig.mobVersion,
        subjectProfiles: subjectProfileIns,
        description: orderrItemGroup.description,
        itemsCount: orderrItemGroup.itemsCount,
        numberOfPersons: orderrItemGroup.numberOfPersons,
        length: orderrItemGroup.length,
        priceListType: orderrItemGroup.priceListType,
        dateStart: moment(orderrItemGroup.dateStart).format(
          "YYYY-MM-DDTHH:mm:ss.000Z"
        ), // TODO: predelat podle otviracky a prevest na CEST
        dateEnd: moment(orderrItemGroup.dateEnd).format(
          "YYYY-MM-DDTHH:mm:ss.000Z"
        ), // TODO: predelat podle otviracky a prevest na CEST
        orderrItemGroupOrderrId: context.state.currentOrderr.id,
        orderrItemGroupProductId: orderrItemGroup.product.id,
        orderrItemGroupLocationId: orderrItemGroup.location.id,
        orderrItemGroupPointMeetingId:
          orderrItemGroup.pointMeeting != null
            ? orderrItemGroup.pointMeeting.id
            : null,
      };

      if (orderrItemGroup.set != null) {
        orderrItemGroupIn.orderrItemGroupSetId = orderrItemGroup.set.id;
      }

      let orderrItemsIn = [];

      for (let i = 0; i < orderrItemGroup.orderrItems.length; i++) {
        let oi = orderrItemGroup.orderrItems[i];

        let oiInput = {
          groups: context.state.appInstance,
          appInstance: context.state.appInstance,
          mobVersion: context.state.mobConfig.mobVersion,
          productId: oi.product.id,
          article:
            oi.article != undefined && oi.article != null ? oi.article : null,
          groupCourse: TransformUtil.transformGroupCourseToGroupCourseIn(
            oi.groupCourse
          ),
          groupCourseDateStart: oi.groupCourseDateStart != undefined && oi.groupCourseDateStart != null ? oi.groupCourseDateStart.format("YYYY-MM-DD") : null,
        };
        if(oi.groupCourseLessons != undefined) {
          oiInput.groupCourseLessons = TransformUtil.transformGroupCourseLessonsToIn(oi.groupCourseLessons);
        } else {
          oiInput.groupCourseLessons = null;
        }
        if (oi.lessons != undefined) {
          oiInput.lessons = oi.lessons;
        } else {
          oiInput.lessons = null;
        }

        if (oi.language != undefined) {
          oiInput.language = oi.language;
        } else {
          oiInput.language = null;
        }

        if (oi.languages != undefined) {
          oiInput.languages = oi.languages;
        } else {
          oiInput.languages = null;
        }

        if (oi.skillLevelClient != undefined) {
          oiInput.skillLevelClient = oi.skillLevelClient;
        } else {
          oiInput.skillLevelClient = null;
        }

        if (oi.sameInstructorRequired != undefined) {
          oiInput.sameInstructorRequired = oi.sameInstructorRequired;
        } else {
          oiInput.sameInstructorRequired = null;
        }

        if (oi.numberOfHoursRequired != undefined) {
          oiInput.numberOfHoursRequired = oi.numberOfHoursRequired;
        } else {
          oiInput.numberOfHoursRequired = null;
        }

        orderrItemsIn.push(oiInput);
      }

      console.log("store action bookOrderrItemGroup -- zahajeno ukladani");

      let addToCartIn = {
        orderrItemGroup: orderrItemGroupIn,
        orderrItems: orderrItemsIn,
      };

      console.log("addToCartIn:");
      console.log(addToCartIn);

      await APIAdapter.addOrderrItemGroupToCart(addToCartIn);

      console.log("store action bookOrderrItemGroup -- ulozeno.");

      context.dispatch("getOrderr", context.state.currentOrderr.id);
    },

    async removeFromCart(context, orderrItemGroup) {
      console.log("removeFromCart -- start");
      await APIAdapter.removeOrderrItemGroupFromCart(orderrItemGroup.id);

      console.log("removeFromCart -- hotovo");

      context.dispatch("getOrderr", context.state.currentOrderr.id);
    },

    async clearCurrentOrderr(context) {
      context.commit("doSetOrderr", null);
    },

    async getOrderr(context, orderrId) {
      let orderr = await APIAdapter.getOrderr(orderrId);
      if (
        orderr.bookingState != "DRAFT" &&
        moment(orderr.expireAt).toDate() < moment().toDate()
      ) {
        context.commit("doSetCurrentOrderrExpired", true);
      } else {
        context.commit("doSetCurrentOrderrExpired", false);
      }

      context.commit("doSetOrderr", orderr);
    },

    async updateOrderrPickupAndPaymentInfo(context, payload) {
      console.log("updateOrderrPickupAndPaymentInfo");
      console.log(payload.orderrId);
      console.log(payload.datePickUp);
      console.log(payload.paymentMethod);

      await APIAdapter.updateOrderrPickupAndPaymentInfo(
        payload.orderrId,
        payload.datePickUp,
        payload.paymentMethod,
        payload.dataTryOut
      );

      // znovu nacist aktualni objednavku
      context.dispatch("getOrderr", payload.orderrId);
    },

    async createSubject(context, contactData) {
      console.log("createSubject -- start");
      let subjectInput = {
        groups: context.state.appInstance,
        appInstance: context.state.appInstance,
        mobVersion: context.state.mobConfig.mobVersion,
        cognitoId: context.state.user,
        name: contactData.name,
        surname: contactData.surname,
        email: contactData.email,
        phone: contactData.phone,
        nationality: null,
        documentType: "ID",
        documentNumber: contactData.documentNumber,
        documentValidTo: null,
      };

      let result = await API.graphql(
        graphqlOperation(createSubject, {
          input: subjectInput,
        })
      );

      console.log(result.data.createSubject);
      console.log("createSubject -- done");
      return result.data.createSubject;
    },

    async addSubjectToOrderr(context, payload) {
      console.log("addSubjectToOrderr -- start");

      let o = await context.dispatch("getOrderr", payload.orderr.id);

      console.log("addSubjectToOrderr -- orderr:");
      console.log(o);
      console.log("addSubjectToOrderr -- subject:");
      console.log(payload.subject);

      o.orderrClientId = payload.subject.id;

      await context.dispatch("updateOrderr", o);

      console.log("addSubjectToOrderr -- start");
    },

    async updateOrderr(context, orderr) {
      console.log("updateOrderr -- start");

      let updateOrderrInput = {
        id: orderr.id,
        groups: orderr.groups,
        appInstance: orderr.appInstance,
        bookingState: orderr.bookingState,
        orderrNumber: orderr.orderrNumber,
        price: orderr.price,
        itemsCount: orderr.itemsCount,
        expireAt: orderr.expireAt,
        orderrClientId: orderr.client.id,
      };

      let updateResult = await API.graphql(
        graphqlOperation(updateOrderr, {
          input: updateOrderrInput,
        })
      );

      console.log(updateResult);

      console.log("updateOrderr -- end");
    },

    async checkoutOrderr(context, payload) {
      console.log("checkoutOrderr -- start");

      let user = null;
      try {
        user = await Auth.currentAuthenticatedUser();
        console.log("user");
        console.log(user);
      } catch (e) {
        console.log("uzivatel neni prihlaseny");
      }

      let createSubjectIn = {
        ...payload.contactData,
        mobVersion: context.state.mobConfig.mobVersion,
        appInstance: context.state.appInstance,
        groups: context.state.appInstance,
        cognitoId:
          user != null
            ? user.signInUserSession.accessToken.payload.username
            : null,
        documentType: "ID",
      };
      console.log(createSubjectIn);

      let orderrId = payload.orderrId;
      console.log(orderrId);

      await APIAdapter.checkoutOrderr(orderrId, createSubjectIn);

      console.log("checkoutOrderr -- end");
    },

    async getPayment(context, paymentId) {
      console.log("getPayment -- start");
      let payment = await APIAdapter.getPayment(paymentId);
      context.commit("doSetCurrentPayment", payment);
      console.log(payment);
      console.log("getPayment -- end");
    },

    async updateCurrentOrderrExpired(context, isExpired) {
      context.commit("doSetCurrentOrderrExpired", isExpired);
    },

    async expireOrderr(context) {
      context.commit("doSetOrderr", null);
      context.commit("doSetCurrentOrderrExpired", false);
    },

    async loadStaticContentList(context) {
      console.log("loadStaticContentList -- start");
      let staticContentList = await APIAdapter.listStaticContent(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      context.commit("doSetStaticContentList", staticContentList);
      console.log(staticContentList);
      console.log("loadStaticContentList -- end");
    },

    async loadRentProductRequirements(context) {
      console.log("loadRentProductRequirements -- start");
      let rentProductRequirements =
        await APIAdapter.listRentProductRequirements(
          context.state.appInstance,
          context.state.mobConfig.mobVersion
        );
      context.commit("doSetRentProductRequirements", rentProductRequirements);
      console.log(rentProductRequirements);
      console.log("loadRentProductRequirements -- end");
    },
  },

  modules: {},
});
